import { __decorate, __extends } from "tslib";
import NeoModel from './NeoModel';
import PropertyInfo from './PropertyInfo';
import PropertyInstance from './PropertyInstance';
import ModelBase from './ModelBase';
import { RequiredRule } from '../Validation/Rules';
import { Utils } from '../Utils';
var ObservableModel = /** @class */ (function (_super) {
    __extends(ObservableModel, _super);
    function ObservableModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.value = null;
        return _this;
    }
    ObservableModel = __decorate([
        NeoModel
    ], ObservableModel);
    return ObservableModel;
}(ModelBase));
var ObservableProperty = /** @class */ (function () {
    function ObservableProperty() {
    }
    /** Creates an observable property which can be used for binding. */
    ObservableProperty.create = function (displayName, defaultValue, options, isRequired) {
        var model = new ObservableModel();
        model.value = defaultValue;
        var propertyInfo = new PropertyInfo("value");
        Utils.populatePartialWithDefaults(propertyInfo, options, true);
        propertyInfo.displayName = displayName;
        if (isRequired) {
            propertyInfo.rules.push(new RequiredRule("{0} is required."));
        }
        return new PropertyInstance(model, propertyInfo);
    };
    /** Creates an observable property which can be used for binding. The value will be required when bound in an editor. */
    ObservableProperty.required = function (displayName, defaultValue, options) {
        return ObservableProperty.create(displayName, defaultValue, options, true);
    };
    return ObservableProperty;
}());
export { ObservableProperty };
